export const CHAIN = {
  ETHEREUM_MAINNET: 'ETHEREUM_MAINNET',
  ETHEREUM_KOVAN: 'ETHEREUM_KOVAN',
  POLYGON: 'POLYGON',
  AURORA: 'AURORA',
  AURORA_TESTNET: 'AURORA_TESTNET',
  POLYGON_MUMBAI: 'POLYGON_MUMBAI',
};
